import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'nordic/image';
import { Typography } from '@andes-landings/typography';
import { makeRedirection, trackAction } from '@/utils';
import { ui } from '@credits-utils/constants';
import { generatorDeeplink } from '../../../../../../../../utils/generatorDeeplink';
import SharedPropsContext from '../../../../../../../contexts/SharedProps';

const { TYPOGRAPHY } = ui;
const CategoryItem = ({ category }) => {
  const { tracks, links, baseUrl, apiPicture, webViewDeeplink, isWebView, deeplinkSpecificCategories, queryParams } = React.useContext(SharedPropsContext);
  const { id, image, name, alt } = category;
  const { url: urlImage, fileExtension } = apiPicture;
  const [urlCategory, setUrlCategory] = useState('');

  const trackInfoMelidata = {
    ...tracks.melidata.events.buyersPage.categoriesSection.goToSpecificCategory,
    event_data: {
      category_id: String(id),
    },
  };

  const handleClick = () => {
    trackAction({
      melidata: trackInfoMelidata,
    });

    makeRedirection({
      callback: urlCategory,
      isWebView,
    });
  };
  useEffect(() => {
    const targetUrl = isWebView
      ? generatorDeeplink({ webViewDeeplink, url: `${deeplinkSpecificCategories}${id}` })
      : `${baseUrl}${links.specificCategories}${id}&${queryParams ?? ''}`;
    setUrlCategory(targetUrl);
  }, [isWebView, id, webViewDeeplink, deeplinkSpecificCategories, baseUrl, links.specificCategories, queryParams]);

  return (
    <>
      <Typography
        className="category-item"
        component={TYPOGRAPHY.COMPONENT.A}
        onClick={handleClick}
      >
        <Image
          onload="on"
          className="category-item__image"
          src={`${urlImage + image}-T${fileExtension}`}
          alt={alt}
        />
        <h4>{name.toUpperCase()}</h4>
      </Typography>
    </>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
};

CategoryItem.defaultProps = {
  category: {},
};

export default CategoryItem;
